<app-barra-menu></app-barra-menu>

<div class="">

    <router-outlet></router-outlet>

</div>
<div class="my-5"></div>

<app-footer></app-footer>